import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"form-square"} maskId="square-filled-radius-0-stroke-1-IconFormSquare"><rect x="3" y="3" width="18" height="18" fill="currentColor"/></CentralIconBase>;
}));

export default IconFormSquare;
